import loadable from '@loadable/component';

const Component = loadable(() => import('./Worklist'));

export default Component;
